import React from 'react'
import UserManagementPage from '../../../../pages/Settings/UserManagement'

export const UserManagementFactory: React.FC = () => {
  return <UserManagementPage />
}
